import {useState, useEffect} from 'react';
import * as ServerComms from '../utilities/ServerComms';
import * as SharedAcross from '../utilities/SharedAcross';
import NormalBtn from '../StockItems/NormalBtn';
import NormalIcon from '../StockItems/NormalIcon';

function App(props) {

  var width = props.width;
  var userDatabaseId = props.userDatabaseId;
  var userTableId = props.userTableId;

  var programSetID = props.programSetID;
  var sessionID = props.sessionID;
  var signKey = props.signKey;
  var userID = props.userID;

  const [tableInfo, setTableInfo] = useState(false);
  const [startNos, setStartNos] = useState(0);
  const [sortCol, setSortCol] = useState('id');
  const [sortDirection, setSortDirection] = useState(0);

  function postLoad(response){
    setTableInfo(response.v);
    setStartNos(response.v[3].v)
    setSortCol(response.v[5].v);
    setSortDirection(response.v[6].v);
  }

  function loadDatabases(){

    ServerComms.fetchSomething({u:'getUserTable', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, startNos, sortCol, sortDirection}, postLoad);
  }

  useEffect(()=>{
    loadDatabases();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps



    if (!tableInfo){
      return <div>Loading...</div>
    } 
//
    function clickColDelete(colName){
      return function(e){
        var p = window.confirm('Please confirm that you would like to delete the '+ colName + ' column');
        if (p){
          ServerComms.fetchSomething({u:'deleteColumn', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, colName, startNos, sortCol, sortDirection}, postLoad);

        }
      }
    }

    function deleteRow(rowId){
      return function(e){
        var p = window.confirm('Please confirm that you would like to delete row '+ rowId);
        if (p){
          ServerComms.fetchSomething({u:'deleteRow', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, rowId, startNos, sortCol, sortDirection}, postLoad);

        }
      }
    }
    var simplStyle = {textAlign:'center', border:'1px solid black', padding:'2px', cursor:'pointer'};

    function changeCell(rowId, oldValSet, colNos, colType){
      return function(e){
        var p;
        var oldVal = oldValSet.v;
        if (oldValSet.t === 'atom'){
          oldVal = '';
        }
        var colName = tableInfo[1].v[colNos].v[0].v;
        if (colType === 'tinyint(1)'){
          if (oldVal === 0){
            p = 1;
          }else{
            p = 0;
          }
        }else{
          p = window.prompt('Please specify a new value for row ' + rowId + ' column ' + colName, oldVal);
        }
        if (p !== undefined){
          ServerComms.fetchSomething({u:'updateCell', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, rowId, newValue:p, colName, startNos, sortCol, sortDirection}, postLoad);
        }
      }
    }
//
    var tRows = tableInfo[2].v.map((aRow, index)=>{
      var rowId = aRow.v[0].v;

      var cells = aRow.v.map((aCell, index2)=>{
        var cellText = aCell.v;
        var colType = tableInfo[1].v[index2].v[1].v;
        if (colType === 'tinyint(1)'){
          if (cellText === 0){
            cellText = 'false';
          }else{
            cellText = 'true';
          }
        }
        if (aCell.t === 'atom'){
          cellText = 'NULL';
        }
        return <td key={index2} style={simplStyle} onClick={changeCell(rowId, aCell, index2, colType)}>{cellText}</td>
//
      })
      return <tr key={index}>{cells}<td key={cells.length} style={{...simplStyle, ...{cursor:''}}} >
          <NormalIcon title='Delete' icon='fe:trash' height='20px' onClick = {deleteRow(rowId)} />
      </td></tr>
//
    });

    var headerStyle = {border:'1px solid black', textAlign:'center', backgroundColor:'#DDD', color:'black', padding:'5px'};

    function changeSort(direction, colName){
      return function(e){
        setSortCol(colName);
        setSortDirection(direction);
        setStartNos(0);
        ServerComms.fetchSomething({u:'getUserTable', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, startNos:0, sortCol:colName, sortDirection:direction}, postLoad);
      }
    }
    
    var tCells = tableInfo[1].v.map((aCell, index)=>{
      var colName = aCell.v[0].v;
      var delPart = null;
      if (colName === 'id'){
      }else{
        delPart = <NormalIcon title='Delete' icon='fe:trash' height='20px' onClick = {clickColDelete(colName)} />
//
      }

      var origTypeName = aCell.v[1].v;
      var typeName = origTypeName;
      if (origTypeName === 'int(11)'){
        typeName = 'Integer';
      }else if (origTypeName === 'tinyint(1)'){
        typeName = 'Boolean';
      }else if (origTypeName === 'decimal(10,10)'){
        typeName = 'Decimal';
      }else if (origTypeName === 'longtext'){
        typeName = 'Long Text';
      }else if (origTypeName === 'varchar(50)'){
        typeName = 'Short Text';
      }else if (origTypeName === 'varchar(5000)'){
        typeName = 'Medium Text';
      }

      var inc = 'fluent:triangle-up-20-regular';
      var dec = 'fluent:triangle-down-20-regular';
      if (colName === sortCol){
        if (sortDirection === 0){
          inc = 'fluent:triangle-up-20-filled'
        }else{
          dec = 'fluent:triangle-down-20-filled';
        }
      }
      return <td key={index} style={headerStyle}><b>{colName}</b><br/>{typeName}<br/>
          <NormalIcon title='Increasing' icon={inc} height='20px' onClick = {changeSort(0, colName)} />
          <NormalIcon title='Decreasing' icon={dec} height='20px' onClick = {changeSort(1, colName)} />
          {delPart}
      </td>
    })
//
    tCells.push(<td key={tCells.length} style={headerStyle}></td>)
//
    function addType(aType){
      return function(e){
        var pp = window.prompt('What is the name of the column?');
        if (pp && pp.trim()){
          var ppT = pp.trim();
          if (SharedAcross.isAlphaNumeric(ppT)){
            var pp2 = ppT.split(' ');
            if (pp2.length > 1){
              window.alert('No spaces');
            }else{
              ServerComms.fetchSomething({u:'addColumn', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, colType:aType.t, colName:ppT, startNos, sortCol, sortDirection}, postLoad);
            }
          }else{
            window.alert('Only Alpha Numeric characters are allowed');
          }
        }

      }
    }

    function addRow(){
      ServerComms.fetchSomething({u:'addRow', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, startNos, sortCol, sortDirection}, postLoad);
    }
//
    var typesToAdd = [{t:'Boolean'}, {t:'Integer'}, {t:'Decimal'}, {t:'Short Text (50 Characters)'}, {t:'Medium Text (5000 Characters)'}, {t:'Long Text'}];
    var addButtons = typesToAdd.map((aType, index)=>{
      return <NormalBtn key={index} icon='ph:plus' onClick={addType(aType)} iconStyle={{margin:'5px'}} title={aType.t + ' Column'} backScreen={true} />
    })

    var counter = tableInfo[4].v;

    var goToStart = {color:'#CCC'};
    var goBack = {color:'#CCC'};
    var goForward = {color:'#CCC'};
    var goToEnd = {color:'#CCC'};
    var dToStart = 0;
    var dBack = 0;
    var dForward = 0;
    var dToEnd = 0;
    
    if (startNos > 0){
      goToStart.color = 'black';
      goToStart.cursor = 'pointer';
      goBack.color = 'black';
      goBack.cursor = 'pointer';
      dToStart = -2;
      dBack = -1;
    }

    var maxEntry = startNos + 20;
    if (maxEntry >= counter){
      maxEntry = counter;
    }else{
      goToEnd.color = 'black';
      goToEnd.cursor = 'pointer';
      goForward.color = 'black';
      goForward.cursor = 'pointer';
      dForward = 1;
      dToEnd = 2;
    }

    function moveForwardBack(direction){
      return function(e) {
        if (direction === 0){
        }else{
          ServerComms.fetchSomething({u:'incrementPosition', programSetID, sessionID, signKey, userID, userDatabaseId, userTableId, startNos, direction, sortCol, sortDirection}, postLoad);
        }
      }
    }


    return <div style={{padding:'10px', width}}>
      <h2>Table {tableInfo[0].v}</h2>
      <table style={{border:'1px solid black', borderCollapse:'collapse'}}>
      <thead>
        <tr>{tCells}
        </tr>
      </thead>
      <tbody>
        {tRows}
        <tr key={tRows.length} style={headerStyle}><td style={{textAlign:'center', cursor:'pointer'}} colSpan={tCells.length} onClick={addRow}>+ Row</td></tr>
      </tbody></table>
      <span style={goToStart} onClick={moveForwardBack(dToStart)}>{"<<"}</span>&nbsp;&nbsp;&nbsp;
      <span style={goBack} onClick={moveForwardBack(dBack)}>{"<"}</span>&nbsp;&nbsp;&nbsp;
      Entries {(startNos + 1)} to {maxEntry} of {counter}.&nbsp;&nbsp;&nbsp;
      <span style={goForward} onClick={moveForwardBack(dForward)}>{">"}</span>&nbsp;&nbsp;&nbsp;
      <span style={goToEnd} onClick={moveForwardBack(dToEnd)}>{">>"}</span>
      <br/><br/>
      {addButtons}

      </div>

}



export default App;
